import { useState, useContext, useEffect } from "react";
import Loader from "../Loader";
import AuthContext from "../../Contexts/Auth/AuthContext";
import { useNavigate, useParams } from "react-router-dom";
import classes from "./Post.module.css";
import { Tooltip } from 'react-tooltip';

const PostCreateUpdate = () => {
  const navigate = useNavigate();
  const authContext = useContext(AuthContext);
  const [isEdit, setIsEdit] = useState(false);

  const params = useParams();
  const id = params.id;

  // if(id) {
  //   setIsEdit(true);
  // }


  const defaultValidationState = {
    content: {
      invalid: false,
      message: "Please enter content that you want to post",
    },
    name: {
      invalid: false,
      message: "Please enter name of a post for reference",
    },
    status: { invalid: false, message: "Please select status" },
    publishTime: { invalid: false, message: "Please choose publish time" },
  };

  const [validateValues, setValidateValues] = useState(defaultValidationState);

  const [response, setResponse] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const [postValues, setPostValues] = useState({
    content: "",
    name: "",
    status: "publish",
    publishTime: "",
    id: "",
  });

  useEffect(() => {
    const fetchData = async () => {
      const response = await fetch(process.env.REACT_APP_EXPRESS_URL + "/post/"+id, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + authContext.token,
        },
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("linkedin-scheduler-token");
          return (window.location.href = "/login");
        }
        const error = await response.json();

        setResponse((prevState) => {
          return { success: false, message: error.message };
        });
        return;
      }

      const data = await response.json();

      // console.log(data.data.client_id,data.data.client_secret,data.data.token)
      setPostValues({
        name: data?.data?.name,
        content: data?.data?.content,
        status: data?.data?.status,
        id: data?.data?._id,
        publishTime: data?.data?.publish_time,
      });
    };

    if(id) {
      setIsEdit(true);
      fetchData();
    }
  }, [id]);

  const isEmpty = (value) => !value || value.trim().length === 0;

  const submitHandler = async (event) => {
    setValidateValues(defaultValidationState);
    event.preventDefault();

    const content = postValues.content;
    const status = postValues.status;
    const publishTime = postValues.publishTime;
    const name = postValues.name;

    let isValid = true;

    if (isEmpty(content)) {
      setValidateValues((prevState) => {
        return {
          ...prevState,
          content: { ...prevState.content, invalid: true },
        };
      });
      isValid = false;
    }

    if (isEmpty(status)) {
      setValidateValues((prevState) => {
        return {
          ...prevState,
          status: { ...prevState.status, invalid: true },
        };
      });
      isValid = false;
    }

    if (isEmpty(name)) {
      setValidateValues((prevState) => {
        return {
          ...prevState,
          name: { ...prevState.name, invalid: true },
        };
      });
      isValid = false;
    }

    const formData = {};

    if (isValid) {
      setIsLoading(true);

      formData.content = content;
      formData.name = name;
      formData.status = status;
      formData.publishTime = publishTime;
      if (postValues.id) {
        formData.id = postValues.id;
      }
      Object.freeze(formData);

      console.table(formData);

      try { 

        const response = await fetch(process.env.REACT_APP_EXPRESS_URL + "/create-post", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + authContext.token,
          },
          body: JSON.stringify(formData),
        });

      //   const response = await fetch('https://api.linkedin.com/v2/userinfo', {
      //     method: 'GET',
      //     headers: {
      //         // 'X-RestLi-Method': 'finder',
      //         Authorization: 'Bearer AQXFwDmyxEMOvyWiDkLy5J8EllvCbQc1v8MDlmDwPMvngVl5W42nM2piQnUpiryhsyDXDadMnBM1-NeA8g8tZ4cTjJszEcDcoEx6xCwP-sICtOWOqkfoLVK1ieUBjQ9ISg5cEL2AkItT3dtcciyaYpN2KYfrtVjQgIwkmdTco5kAhK6NDcF0yy83bx4ElKCQvVaJD5LLCZUA5m5zcqgKdEX-JQBQkRVAwivY5mFIjvb8bSf4inRiOye6_G_aPu6WojtBR71knTg2uudmhxpJ5NcyhJRLgdbGgTHbEICKrelvetnI9q9sP4AS-GV4BOsrDXPLdhwrgzdNnwLBfvfO7AAaim4Ckg',
      //         // 'Connection': 'Keep-Alive',
      //         'Content-Type': 'application/json',
      //         'LinkedIn-Version': '202304',
      //         'X-Restli-Protocol-Version': '2.0.0',
      //         // 'Access-Control-Allow-Origin' : '*'
      //     },
      //     timeout: 10000 // Set timeout to 10 seconds
      // });
        if (!response.ok) {
          if (response.status === 401) {
            localStorage.removeItem("linkedin-scheduler-token");
            return (window.location.href = "/login");
          }
          const error = await response.json();
          console.error(error);

          if (response.status === 422) {
            console.table(error.errors);
            for (const key of error.errors) {
              setValidateValues((prevState) => {
                return {
                  ...prevState,
                  [key.path]: { message: [key.msg], invalid: true },
                };
              });
            }
          } else {
            setResponse((prevState) => {
              return { success: false, message: error.message };
            });
          }

          return;
        }
        const data = await response.json();

        setResponse((prevState) => {
          return { success: true, message: data.message };
        });
        setTimeout(() => {
          navigate('/panel/posts');
        },3000)
      } catch (error) {
        console.error('error',error);
        setResponse((prevState) => ({
          success: false,
          message: "Something went wrong. Please try again.",
        }));
      } finally {
        setIsLoading(false);
        setTimeout(() => {
          setResponse(null);
        }, 3000);
      }
    }
  };

  const changeHandler = (event) => {
    setPostValues((prevState) => {
      return { ...prevState, [event.target.name]: event.target.value };
    });
  };

  const closeAlert = () => setResponse(null);

  return (
    <div className="p-6 pt-26 text-white overflow-hidden min-h-screen">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-6">
          <h4 className="text-l font-semibold">Post</h4>
          <div className="text-l text-gray-400 md:mt-0">
            <button type="button" className="text-blue" onClick={() => navigate("/panel/dashboard")}>Home</button>
            <span> / </span>
            <button type="button" className="text-blue" onClick={() => navigate("/panel/posts")}>Posts</button>
            <span> / Post</span>
          </div>
        </div>

        <div className="bg-gray-800 rounded-lg p-6 shadow-md mx-auto space-y-6 w-full">
          {isLoading && <Loader />}
          {response && (
            <div
              className={`relative px-4 py-3 rounded-lg text-sm border transition-opacity duration-500 ease-in-out ${
                response.success
                  ? 'bg-green-100 text-green-600 border-green-300'
                  : 'bg-rose-100 text-rose-600 border-rose-300'
              }`}
            >
              <span>{response.message}</span>
              <button
                className="absolute right-2 top-1 text-xl text-gray-500 hover:text-gray-700"
                onClick={closeAlert}
                aria-label="Close"
              >
                &times;
              </button>
            </div>
          )}

          <form className="space-y-4" onSubmit={submitHandler}>
            <div>
              <label className="block mb-1 text-sm text-gray-300 flex items-center gap-2">
                Post Name
                <div className="relative group inline-block">
                  <i className="fas fa-question-circle text-gray-400 hover:text-white ml-1" style={{ cursor: 'pointer' }}></i>

                  <div
                    className="absolute left-full top-1/2 ml-2 transform -translate-y-1/2 
                              opacity-0 group-hover:opacity-100 
                              transition-opacity duration-200 
                              bg-gray-700 text-white text-xs px-3 py-1 rounded shadow-lg 
                              z-10 whitespace-nowrap 
                              pointer-events-none group-hover:pointer-events-auto"
                  >
                    The name is just for reference, <br/>it will not pe posted on linkedin.
                  </div>
                </div>
              </label> 
              <input
                type="text"
                autoFocus={true}
                className={`w-full px-4 py-2 border border-gray-600 rounded-lg bg-gray-700 text-white focus:outline-none focus:ring-2 focus:ring-blue-500 ${
                  validateValues.name.invalid ? 'border-rose-500' : ''
                }`}
                name="name"
                id="name"
                placeholder="Name of the post for reference"
                value={postValues.name}
                onChange={changeHandler}
              />
              {validateValues.name.invalid && (
                <span className="text-rose-400 text-sm mt-1 block">{validateValues.name.message}</span>
              )}
            </div>

            <div>
              <label className="block mb-1 text-sm text-gray-300 flex items-center gap-2">
                Post Content
                <div className="relative group inline-block">
                  <i className="fas fa-question-circle text-gray-400 hover:text-white ml-1" style={{ cursor: 'pointer' }}></i>

                  <div
                    className="absolute left-full top-1/2 ml-2 transform -translate-y-1/2 
                              opacity-0 group-hover:opacity-100 
                              transition-opacity duration-200 
                              bg-gray-700 text-white text-xs px-3 py-1 rounded shadow-lg 
                              z-10 whitespace-nowrap 
                              pointer-events-none group-hover:pointer-events-auto"
                  >
                    Enter the content that you <br/> want to post on linkedin.
                  </div>
                </div>
              </label>
              <textarea
                className={`w-full px-4 py-2 border border-gray-600 rounded-lg bg-gray-700 text-white focus:outline-none focus:ring-2 focus:ring-blue-500 ${
                  validateValues.content.invalid ? 'border-rose-500' : ''
                }`}
                name="content"
                id="content"
                rows="8"
                placeholder="What do you want to post about?"
                value={postValues.content}
                onChange={changeHandler}
              />
              {validateValues.content.invalid && (
                <span className="text-rose-400 text-sm mt-1 block">{validateValues.content.message}</span>
              )}
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {/* RADIO */}
              <div>
                <label className="block mb-1 text-sm text-gray-300">Status</label>
                <div className="flex gap-4 text-sm">
                  <label className="inline-flex items-center">
                    <input type="radio" className="form-radio text-blue-500" name="status"
                            value="publish"
                            checked={postValues.status==='publish'}
                            onChange={changeHandler} />
                    <span className="ml-2">Publish</span>
                  </label>
                  <label className="inline-flex items-center">
                    <input type="radio" className="form-radio text-blue-500" name="status"
                            value="draft"
                            checked={postValues.status==='draft'}
                            onChange={changeHandler} />
                    <span className="ml-2">Draft</span>
                  </label>
                </div>
              </div>

              {/* DATETIME */}
              <div>
                <label className="block mb-1 text-sm text-gray-300">Publish at</label>
                <input
                  type="datetime-local"
                  className="w-full px-4 py-2 rounded-lg bg-gray-700 text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  id="publishTime"
                  name="publishTime"
                  onChange={changeHandler}
                  disabled={postValues.status === "draft"}
                  placeholder="enter date"
                  value={postValues.publishTime}
                />
                {validateValues.publishTime.invalid && (
                <span className="text-rose-400 text-sm mt-1 block">{validateValues.publishTime.message}</span>
              )}
              </div>
            </div>

            <button
              type="submit"
              id="userSave"
              className="w-25 mt-2 bg-blue-600 text-white py-2 rounded-lg hover:bg-blue-700 transition"
            >
              Save Post
            </button>
          </form>
        </div>
      </div>
  );
};

export default PostCreateUpdate;
